import { render } from "./ReportesEmpresas.vue?vue&type=template&id=34d78050&scoped=true"
import script from "./ReportesEmpresas.vue?vue&type=script&lang=js"
export * from "./ReportesEmpresas.vue?vue&type=script&lang=js"

import "./ReportesEmpresas.vue?vue&type=style&index=0&id=34d78050&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34d78050"]])

export default __exports__